import React, { Component } from 'react';
import {Nav, NavItem, Tab} from 'react-bootstrap';

class QuestionTabs extends Component {
    render() {
        return (
            <div>
                <Tab.Container className="tab-container" id="left-tabs-example" defaultActiveKey="question">
                    <div>
                    <Nav bsStyle="tabs">
                        <NavItem eventKey="question">Question</NavItem>
                        <NavItem eventKey="comments">Comments</NavItem>
                    </Nav>
                    <Tab.Content animation>
                        <Tab.Pane eventKey="question">
                            {this.props.questionView}
                        </Tab.Pane>
                        <Tab.Pane eventKey="comments">
                            {this.props.commentsView}
                        </Tab.Pane>
                    </Tab.Content>
                    </div>
                </Tab.Container>
            </div>
        );
    }
}

export default QuestionTabs;